<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'TaxList' }">{{page_alias}}</el-breadcrumb-item>
            <el-breadcrumb-item>Add</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form 
     ref="tax" 
     :rules="rules.tax"
     :model="tax"
     :label-position="label_position">

      <el-form-item label="Name" prop="name">
          <el-input v-model="tax.name"></el-input>
      </el-form-item>

      <el-form-item label="Description" prop="description">
          <el-input v-model="tax.description"></el-input>
      </el-form-item>

      <el-form-item label="Sort Order" prop="sort_order">
          <el-input-number :min="0" v-model="tax.sort_order"></el-input-number>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="addTax('tax')">Add Tax</el-button>
      </el-form-item>
    </el-form>

    <pre>{{$data}}</pre>

  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return {
        config: Config.config,
        page_alias: 'Tax Class',
        page_slug: 'add-tax',
        label_position: 'top',
        rules:{
          tax: {
            name: [
              { required: true, message: 'Please Enter Name', trigger: 'blur' }
            ],
            description: [
              { required: true, message: 'Please Enter Description', trigger: 'blur' },
            ],
            sort_order: [
                {  required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
                { type: 'integer', message: 'Must Be A Number', trigger: 'blur'}
            ],
          }
        },
        tax: {
            name:'',
            description:'',
            sort_order:'',
            created_user_id: '',
            updated_user_id: '',
        },
      };
    },

    mounted: function() {
      const me = this;
    },

    methods: {
      addTax: function(formName) {
        console.log('add tax function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            var jwt = Utils.decodejwt();
            me.tax.created_user_id = jwt.sub;
            me.tax.updated_user_id = jwt.sub;
            me.$http.post(me.config.api + 'taxClasses', me.tax).then(
              response => {
              console.log('success putting data')  
              console.log(response.status);
              console.log(response.statusText);
              me.$notify({
                title: 'Success',
                message: 'The Tax Was Added',
                type: 'success'
              });
                me.$router.push({name: 'TaxList'});
            }, response => {
              console.log('Error Getting Data');
              console.log(response.status);
              console.log(response.statusText);
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });                  
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/tax/TaxAdd.vue